export const fetchCommodities = "materials/fetchCommodities";
export const loadCommodities = "materials/loadCommodities";
export const createMaterial = "materials/createMaterial";
export const newMaterial = "materials/newMaterial";
